/* This file was auto-generated by 'generate-theme.js'. Do NOT edit this manually. */

export const primary_1200 = '#0B3A23';
export const primary_1100 = '#0F5533';
export const primary_1000 = '#126F43';
export const primary_900 = '#188652';
export const primary_800 = '#19A463';
export const primary_700 = '#1DBF73';
export const primary_600 = '#3FCA89';
export const primary_500 = '#62D49F';
export const primary_400 = '#84DFB5';
export const primary_300 = '#A6EACA';
export const primary_200 = '#C9F4E0';
export const primary_100 = '#E8FAF4';
export const business_1200 = '#0D084D';
export const business_1100 = '#1E1692';
export const business_1000 = '#2E25AD';
export const business_900 = '#2E25AD';
export const business_800 = '#2E25AD';
export const business_700 = '#584AFF';
export const business_600 = '#584AFF';
export const business_500 = '#B1ABFF';
export const business_400 = '#B1ABFF';
export const business_300 = '#B1ABFF';
export const business_200 = '#E4E3FF';
export const business_100 = '#F6F6FF';
export const pro_1200 = '#026A5D';
export const pro_1100 = '#027C6C';
export const pro_1000 = '#028D7B';
export const pro_900 = '#029F8B';
export const pro_800 = '#02B09A';
export const pro_700 = '#02C2A9';
export const pro_600 = '#28CCB7';
export const pro_500 = '#4DD6C5';
export const pro_400 = '#73E1D3';
export const pro_300 = '#99EBE0';
export const pro_200 = '#BEF5EE';
export const pro_100 = '#E8FFFC';
export const pink_1200 = '#642744';
export const pink_1100 = '#833359';
export const pink_1000 = '#A23F6E';
export const pink_900 = '#C14A83';
export const pink_800 = '#E05698';
export const pink_700 = '#FF62AD';
export const pink_600 = '#FF7AB9';
export const pink_500 = '#FF91C6';
export const pink_400 = '#FFA9D2';
export const pink_300 = '#FFC0DE';
export const pink_200 = '#FFD7EB';
export const pink_100 = '#FFEFF7';
export const teal_1200 = '#065A60';
export const teal_1100 = '#10727B';
export const teal_1000 = '#1B8996';
export const teal_900 = '#25A1B0';
export const teal_800 = '#30B8CB';
export const teal_700 = '#3AD0E6';
export const teal_600 = '#57D7EA';
export const teal_500 = '#75DFEE';
export const teal_400 = '#92E6F3';
export const teal_300 = '#AFEDF7';
export const teal_200 = '#CDF5FB';
export const teal_100 = '#ECFCFF';
export const lime_1200 = '#254200';
export const lime_1100 = '#465A00';
export const lime_1000 = '#687200';
export const lime_900 = '#7D8900';
export const lime_800 = '#BBCE00';
export const lime_700 = '#D0E500';
export const lime_600 = '#DAEA3D';
export const lime_500 = '#E3EE74';
export const lime_400 = '#E8F094';
export const lime_300 = '#EDF2B3';
export const lime_200 = '#F1F4CB';
export const lime_100 = '#F8F9E5';
export const yellow_1200 = '#825723';
export const yellow_1100 = '#9B6928';
export const yellow_1000 = '#B47C2E';
export const yellow_900 = '#CD8E33';
export const yellow_800 = '#E6A139';
export const yellow_700 = '#FFB33E';
export const yellow_600 = '#FFBE5B';
export const yellow_500 = '#FFCA79';
export const yellow_400 = '#FFD596';
export const yellow_300 = '#FFE0B3';
export const yellow_200 = '#FFECD1';
export const yellow_100 = '#FFF7EE';
export const orange_1200 = '#804317';
export const orange_1100 = '#99501B';
export const orange_1000 = '#B25D1F';
export const orange_900 = '#CA6923';
export const orange_800 = '#E37627';
export const orange_700 = '#FC832B';
export const orange_600 = '#FD964B';
export const orange_500 = '#FDA86A';
export const orange_400 = '#FEBB8A';
export const orange_300 = '#FECDAA';
export const orange_200 = '#FEDFC9';
export const orange_100 = '#FFF2E9';
export const red_1200 = '#782020';
export const red_1100 = '#912626';
export const red_1000 = '#AB2D2D';
export const red_900 = '#C43333';
export const red_800 = '#D93C3C';
export const red_700 = '#F74040';
export const red_600 = '#F85D5D';
export const red_500 = '#FA7A7A';
export const red_400 = '#FB9797';
export const red_300 = '#FCB3B3';
export const red_200 = '#FED0D0';
export const red_100 = '#FFEDED';
export const purple_1200 = '#462072';
export const purple_1100 = '#56288A';
export const purple_1000 = '#6731A1';
export const purple_900 = '#7739B9';
export const purple_800 = '#8842D0';
export const purple_700 = '#984AE8';
export const purple_600 = '#A866EC';
export const purple_500 = '#B881F0';
export const purple_400 = '#C89DF3';
export const purple_300 = '#D8B9F7';
export const purple_200 = '#E8D4FB';
export const purple_100 = '#F8F0FF';
export const blue_1200 = '#122349';
export const blue_1100 = '#1D3369';
export const blue_1000 = '#284389';
export const blue_900 = '#3453A8';
export const blue_800 = '#3F63C8';
export const blue_700 = '#446EE7';
export const blue_600 = '#6689EC';
export const blue_500 = '#819EF0';
export const blue_400 = '#9DB4F3';
export const blue_300 = '#B9C9F7';
export const blue_200 = '#D4DEFB';
export const blue_100 = '#F0F4FF';
export const green_1200 = '#0B3A23';
export const green_1100 = '#0F5533';
export const green_1000 = '#126F43';
export const green_900 = '#188652';
export const green_800 = '#19A463';
export const green_700 = '#1DBF73';
export const green_600 = '#3FCA89';
export const green_500 = '#62D49F';
export const green_400 = '#84DFB5';
export const green_300 = '#A6EACA';
export const green_200 = '#C9F4E0';
export const green_100 = '#E8FAF4';
export const grey_1200 = '#222325';
export const grey_1100 = '#404145';
export const grey_1000 = '#62646A';
export const grey_900 = '#74767E';
export const grey_800 = '#95979D';
export const grey_700 = '#B5B6BA';
export const grey_600 = '#C5C6C9';
export const grey_500 = '#DADBDD';
export const grey_400 = '#E4E5E7';
export const grey_300 = '#EFEFF0';
export const grey_200 = '#F5F5F5';
export const grey_100 = '#FAFAFA';
export const fiverr_error = '#F74040';
export const fiverr_success = '#19A463';
export const fiverr_green = '#1DBF73';
export const black = '#000';
export const white = '#fff';

export const primary = 'primary';
export const business = 'business';
export const pro = 'pro';
export const pink = 'pink';
export const teal = 'teal';
export const lime = 'lime';
export const yellow = 'yellow';
export const orange = 'orange';
export const red = 'red';
export const purple = 'purple';
export const blue = 'blue';
export const green = 'green';
export const grey = 'grey';

export const dropShadows = {
    'aa': 'drop-shadow(0 0 .880517px rgba(0, 0, 0, .0288)) drop-shadow(0 0 2.29197px rgba(0, 0, 0, .03)) drop-shadow(0 0 5.52px rgba(0, 0, 0, .0543)) drop-shadow(0 0 11px rgba(0, 0, 0, .09))',
    'z1': 'drop-shadow(0 1.2px 1.92251px rgba(0, 0, 0, .02)) drop-shadow(0 2px 3.68135px rgba(0, 0, 0, .04)) drop-shadow(0 1px 5px rgba(0, 0, 0, .05))',
    'z2': 'drop-shadow(0 .14px 2.29266px rgba(0, 0, 0, .0323114)) drop-shadow(0 .37px 4.42626px rgba(0, 0, 0, .0476886)) drop-shadow(0 3px 7px rgba(0, 0, 0, .09))',
    'z3': 'drop-shadow(0 .08px 2.55728px rgba(0, 0, 0, .0525061)) drop-shadow(0 1.28px 5.57858px rgba(0, 0, 0, .0774939)) drop-shadow(0 3px 10px rgba(0, 0, 0, .13))',
    'z4': 'drop-shadow(0 .266004px 1.13052px rgba(0, 0, 0, .0686618)) drop-shadow(0 .893452px 3.79717px rgba(0, 0, 0, .101338)) drop-shadow(0 5px 17px rgba(0, 0, 0, .17))',
    'z5': 'drop-shadow(0 0 2.17382px rgba(0, 0, 0, .0487776)) drop-shadow(0 1.75px 6.01034px rgba(0, 0, 0, .07)) drop-shadow(0 3.63px 14.4706px rgba(0, 0, 0, .0912224)) drop-shadow(0 22px 48px rgba(0, 0, 0, .14))'
};
export const dropShadowZ5 = 'drop-shadow(0 0 2.17382px rgba(0, 0, 0, .0487776)) drop-shadow(0 1.75px 6.01034px rgba(0, 0, 0, .07)) drop-shadow(0 3.63px 14.4706px rgba(0, 0, 0, .0912224)) drop-shadow(0 22px 48px rgba(0, 0, 0, .14))';
export const dropShadowZ4 = 'drop-shadow(0 .266004px 1.13052px rgba(0, 0, 0, .0686618)) drop-shadow(0 .893452px 3.79717px rgba(0, 0, 0, .101338)) drop-shadow(0 5px 17px rgba(0, 0, 0, .17))';
export const dropShadowZ3 = 'drop-shadow(0 .08px 2.55728px rgba(0, 0, 0, .0525061)) drop-shadow(0 1.28px 5.57858px rgba(0, 0, 0, .0774939)) drop-shadow(0 3px 10px rgba(0, 0, 0, .13))';
export const dropShadowZ2 = 'drop-shadow(0 .14px 2.29266px rgba(0, 0, 0, .0323114)) drop-shadow(0 .37px 4.42626px rgba(0, 0, 0, .0476886)) drop-shadow(0 3px 7px rgba(0, 0, 0, .09))';
export const dropShadowZ1 = 'drop-shadow(0 1.2px 1.92251px rgba(0, 0, 0, .02)) drop-shadow(0 2px 3.68135px rgba(0, 0, 0, .04)) drop-shadow(0 1px 5px rgba(0, 0, 0, .05))';
export const dropShadowAa = 'drop-shadow(0 0 .880517px rgba(0, 0, 0, .0288)) drop-shadow(0 0 2.29197px rgba(0, 0, 0, .03)) drop-shadow(0 0 5.52px rgba(0, 0, 0, .0543)) drop-shadow(0 0 11px rgba(0, 0, 0, .09))';

export const boxShadows = {
    'aa': '(0 0 .880517px rgba(0, 0, 0, .0288), 0 0 2.29197px rgba(0, 0, 0, .03), 0 0 5.52px rgba(0, 0, 0, .0543), 0 0 11px rgba(0, 0, 0, .09))',
    'z1': '(0 1.2px 1.92251px rgba(0, 0, 0, .02), 0 2px 3.68135px rgba(0, 0, 0, .04), 0 1px 5px rgba(0, 0, 0, .05))',
    'z2': '(0 .14px 2.29266px rgba(0, 0, 0, .0323114), 0 .37px 4.42626px rgba(0, 0, 0, .0476886), 0 3px 7px rgba(0, 0, 0, .09))',
    'z3': '(0 .08px 2.55728px rgba(0, 0, 0, .0525061), 0 1.28px 5.57858px rgba(0, 0, 0, .0774939), 0 3px 10px rgba(0, 0, 0, .13))',
    'z4': '(0 .266004px 1.13052px rgba(0, 0, 0, .0686618), 0 .893452px 3.79717px rgba(0, 0, 0, .101338), 0 5px 17px rgba(0, 0, 0, .17))',
    'z5': '(0 0 2.17382px rgba(0, 0, 0, .0487776), 0 1.75px 6.01034px rgba(0, 0, 0, .07), 0 3.63px 14.4706px rgba(0, 0, 0, .0912224), 0 22px 48px rgba(0, 0, 0, .14))'
};
export const boxShadowZ5 = '(0 0 2.17382px rgba(0, 0, 0, .0487776), 0 1.75px 6.01034px rgba(0, 0, 0, .07), 0 3.63px 14.4706px rgba(0, 0, 0, .0912224), 0 22px 48px rgba(0, 0, 0, .14))';
export const boxShadowZ4 = '(0 .266004px 1.13052px rgba(0, 0, 0, .0686618), 0 .893452px 3.79717px rgba(0, 0, 0, .101338), 0 5px 17px rgba(0, 0, 0, .17))';
export const boxShadowZ3 = '(0 .08px 2.55728px rgba(0, 0, 0, .0525061), 0 1.28px 5.57858px rgba(0, 0, 0, .0774939), 0 3px 10px rgba(0, 0, 0, .13))';
export const boxShadowZ2 = '(0 .14px 2.29266px rgba(0, 0, 0, .0323114), 0 .37px 4.42626px rgba(0, 0, 0, .0476886), 0 3px 7px rgba(0, 0, 0, .09))';
export const boxShadowZ1 = '(0 1.2px 1.92251px rgba(0, 0, 0, .02), 0 2px 3.68135px rgba(0, 0, 0, .04), 0 1px 5px rgba(0, 0, 0, .05))';
export const boxShadowAa = '(0 0 .880517px rgba(0, 0, 0, .0288), 0 0 2.29197px rgba(0, 0, 0, .03), 0 0 5.52px rgba(0, 0, 0, .0543), 0 0 11px rgba(0, 0, 0, .09))';

export const headingSizes = {
    '2xl': 'text-display-1',
    'xl': 'text-display-2',
    'lg': 'text-display-3',
    'md': 'text-display-4',
    'sm': 'text-display-5',
    'xs': 'text-display-6'
};
export const headingSizeXs = 'text-display-6';
export const headingSizeSm = 'text-display-5';
export const headingSizeMd = 'text-display-4';
export const headingSizeLg = 'text-display-3';
export const headingSizeXl = 'text-display-2';
export const headingSize2xl = 'text-display-1';

export const textSizes = {
    '2xl': 'tbody-2',
    'xl': 'tbody-3',
    'lg': 'tbody-4',
    'md': 'tbody-5',
    'default': 'tbody-5',
    'sm': 'tbody-6',
    'xs': 'tbody-7'
};
export const textSizeXs = 'tbody-7';
export const textSizeSm = 'tbody-6';
export const textSizeDefault = 'tbody-5';
export const textSizeMd = 'tbody-5';
export const textSizeLg = 'tbody-4';
export const textSizeXl = 'tbody-3';
export const textSize2xl = 'tbody-2';

export const sizes = {
    '1_2': '50%',
    '1_3': '33.33%',
    '2_3': '66.66%',
    '1_4': '25%',
    '2_4': '50%',
    '3_4': '75%'
};
export const size3_4 = '75%';
export const size2_4 = '50%';
export const size1_4 = '25%';
export const size2_3 = '66.66%';
export const size1_3 = '33.33%';
export const size1_2 = '50%';

export const spacings = {
    '1': 4,
    '2': 8,
    '3': 12,
    '4': 16,
    '5': 20,
    '6': 24,
    '7': 28,
    '8': 32,
    '9': 36,
    '10': 40,
    '12': 48,
    '14': 56,
    '16': 64,
    '20': 80,
    '24': 96,
    '28': 112,
    '32': 128,
    '36': 144,
    '40': 160,
    'px': 1,
    '_5': 2,
    '1_5': 6,
    '2_5': 10
};
export const spacing2_5 = 10;
export const spacing1_5 = 6;
export const spacing_5 = 2;
export const spacingPx = 1;
export const spacing40 = 160;
export const spacing36 = 144;
export const spacing32 = 128;
export const spacing28 = 112;
export const spacing24 = 96;
export const spacing20 = 80;
export const spacing16 = 64;
export const spacing14 = 56;
export const spacing12 = 48;
export const spacing10 = 40;
export const spacing9 = 36;
export const spacing8 = 32;
export const spacing7 = 28;
export const spacing6 = 24;
export const spacing5 = 20;
export const spacing4 = 16;
export const spacing3 = 12;
export const spacing2 = 8;
export const spacing1 = 4;

export const borderRadiuses = {
    'none': 0,
    'sm': 4,
    'md': 6,
    'lg': 8,
    'xl': 12,
    'circle': 9999
};
export const borderRadiusCircle = 9999;
export const borderRadiusXl = 12;
export const borderRadiusLg = 8;
export const borderRadiusMd = 6;
export const borderRadiusSm = 4;
export const borderRadiusNone = 0;

export const fontSerif = 'Georgia, "Times New Roman", serif';
export const fontAccent = '"Macan", "Helvetica Neue", Helvetica, Arial, sans-serif';
export const fontDomaine = '"DomaineDisplay", "Helvetica Neue", Helvetica, Arial, sans-serif';
export const fontPrimary = '"Macan", "Helvetica Neue", Helvetica, Arial, sans-serif';

export const maxWidth = 1400;

export const breakpointReverses = {
    'xs': 319,
    'sm': 599,
    'md': 899,
    'lg': 1159,
    'xl': 1759
};
export const breakpointReverseXl = 1759;
export const breakpointReverseLg = 1159;
export const breakpointReverseMd = 899;
export const breakpointReverseSm = 599;
export const breakpointReverseXs = 319;

export const breakpoints = {
    'xs': 320,
    'sm': 600,
    'md': 900,
    'lg': 1160,
    'xl': 1760
};
export const breakpointXl = 1760;
export const breakpointLg = 1160;
export const breakpointMd = 900;
export const breakpointSm = 600;
export const breakpointXs = 320;

export const animationTimingFunctions = {
    'standard': 'cubic-bezier(.75, 0, .25, 1)',
    'entrance': 'cubic-bezier(0, .7, 0, 1)',
    'exit': 'cubic-bezier(0, 0, 1, .3)'
};
export const animationTimingFunctionExit = 'cubic-bezier(0, 0, 1, .3)';
export const animationTimingFunctionEntrance = 'cubic-bezier(0, .7, 0, 1)';
export const animationTimingFunctionStandard = 'cubic-bezier(.75, 0, .25, 1)';
export const animationDurationSlows = {
    '01': 370,
    '02': 400,
    '03': 500
};
export const animationDurationSlow03 = 500;
export const animationDurationSlow02 = 400;
export const animationDurationSlow01 = 370;
export const animationDurationModerates = {
    '01': 200,
    '02': 250,
    '03': 300
};
export const animationDurationModerate03 = 300;
export const animationDurationModerate02 = 250;
export const animationDurationModerate01 = 200;
export const animationDurationFasts = {
    '01': 70,
    '02': 100,
    '03': 120
};
export const animationDurationFast03 = 120;
export const animationDurationFast02 = 100;
export const animationDurationFast01 = 70;

export const colorWeights = [
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900,
    1000,
    1100,
    1200
];

export const colorNames = [
    'grey',
    'green',
    'blue',
    'purple',
    'red',
    'orange',
    'yellow',
    'lime',
    'teal',
    'pink',
    'pro',
    'business',
    'primary'
];

export const colors = {
    'grey': {
        '100': '#FAFAFA',
        '200': '#F5F5F5',
        '300': '#EFEFF0',
        '400': '#E4E5E7',
        '500': '#DADBDD',
        '600': '#C5C6C9',
        '700': '#B5B6BA',
        '800': '#95979D',
        '900': '#74767E',
        '1000': '#62646A',
        '1100': '#404145',
        '1200': '#222325'
    },
    'green': {
        '100': '#E8FAF4',
        '200': '#C9F4E0',
        '300': '#A6EACA',
        '400': '#84DFB5',
        '500': '#62D49F',
        '600': '#3FCA89',
        '700': '#1DBF73',
        '800': '#19A463',
        '900': '#188652',
        '1000': '#126F43',
        '1100': '#0F5533',
        '1200': '#0B3A23'
    },
    'blue': {
        '100': '#F0F4FF',
        '200': '#D4DEFB',
        '300': '#B9C9F7',
        '400': '#9DB4F3',
        '500': '#819EF0',
        '600': '#6689EC',
        '700': '#446EE7',
        '800': '#3F63C8',
        '900': '#3453A8',
        '1000': '#284389',
        '1100': '#1D3369',
        '1200': '#122349'
    },
    'purple': {
        '100': '#F8F0FF',
        '200': '#E8D4FB',
        '300': '#D8B9F7',
        '400': '#C89DF3',
        '500': '#B881F0',
        '600': '#A866EC',
        '700': '#984AE8',
        '800': '#8842D0',
        '900': '#7739B9',
        '1000': '#6731A1',
        '1100': '#56288A',
        '1200': '#462072'
    },
    'red': {
        '100': '#FFEDED',
        '200': '#FED0D0',
        '300': '#FCB3B3',
        '400': '#FB9797',
        '500': '#FA7A7A',
        '600': '#F85D5D',
        '700': '#F74040',
        '800': '#D93C3C',
        '900': '#C43333',
        '1000': '#AB2D2D',
        '1100': '#912626',
        '1200': '#782020'
    },
    'orange': {
        '100': '#FFF2E9',
        '200': '#FEDFC9',
        '300': '#FECDAA',
        '400': '#FEBB8A',
        '500': '#FDA86A',
        '600': '#FD964B',
        '700': '#FC832B',
        '800': '#E37627',
        '900': '#CA6923',
        '1000': '#B25D1F',
        '1100': '#99501B',
        '1200': '#804317'
    },
    'yellow': {
        '100': '#FFF7EE',
        '200': '#FFECD1',
        '300': '#FFE0B3',
        '400': '#FFD596',
        '500': '#FFCA79',
        '600': '#FFBE5B',
        '700': '#FFB33E',
        '800': '#E6A139',
        '900': '#CD8E33',
        '1000': '#B47C2E',
        '1100': '#9B6928',
        '1200': '#825723'
    },
    'lime': {
        '100': '#F8F9E5',
        '200': '#F1F4CB',
        '300': '#EDF2B3',
        '400': '#E8F094',
        '500': '#E3EE74',
        '600': '#DAEA3D',
        '700': '#D0E500',
        '800': '#BBCE00',
        '900': '#7D8900',
        '1000': '#687200',
        '1100': '#465A00',
        '1200': '#254200'
    },
    'teal': {
        '100': '#ECFCFF',
        '200': '#CDF5FB',
        '300': '#AFEDF7',
        '400': '#92E6F3',
        '500': '#75DFEE',
        '600': '#57D7EA',
        '700': '#3AD0E6',
        '800': '#30B8CB',
        '900': '#25A1B0',
        '1000': '#1B8996',
        '1100': '#10727B',
        '1200': '#065A60'
    },
    'pink': {
        '100': '#FFEFF7',
        '200': '#FFD7EB',
        '300': '#FFC0DE',
        '400': '#FFA9D2',
        '500': '#FF91C6',
        '600': '#FF7AB9',
        '700': '#FF62AD',
        '800': '#E05698',
        '900': '#C14A83',
        '1000': '#A23F6E',
        '1100': '#833359',
        '1200': '#642744'
    },
    'pro': {
        '100': '#E8FFFC',
        '200': '#BEF5EE',
        '300': '#99EBE0',
        '400': '#73E1D3',
        '500': '#4DD6C5',
        '600': '#28CCB7',
        '700': '#02C2A9',
        '800': '#02B09A',
        '900': '#029F8B',
        '1000': '#028D7B',
        '1100': '#027C6C',
        '1200': '#026A5D'
    },
    'business': {
        '100': '#F6F6FF',
        '200': '#E4E3FF',
        '300': '#B1ABFF',
        '400': '#B1ABFF',
        '500': '#B1ABFF',
        '600': '#584AFF',
        '700': '#584AFF',
        '800': '#2E25AD',
        '900': '#2E25AD',
        '1000': '#2E25AD',
        '1100': '#1E1692',
        '1200': '#0D084D'
    },
    'primary': {
        '100': '#E8FAF4',
        '200': '#C9F4E0',
        '300': '#A6EACA',
        '400': '#84DFB5',
        '500': '#62D49F',
        '600': '#3FCA89',
        '700': '#1DBF73',
        '800': '#19A463',
        '900': '#188652',
        '1000': '#126F43',
        '1100': '#0F5533',
        '1200': '#0B3A23'
    }
};
export const colorPrimarys = {
    '100': '#E8FAF4',
    '200': '#C9F4E0',
    '300': '#A6EACA',
    '400': '#84DFB5',
    '500': '#62D49F',
    '600': '#3FCA89',
    '700': '#1DBF73',
    '800': '#19A463',
    '900': '#188652',
    '1000': '#126F43',
    '1100': '#0F5533',
    '1200': '#0B3A23'
};
export const colorPrimary1200 = '#0B3A23';
export const colorPrimary1100 = '#0F5533';
export const colorPrimary1000 = '#126F43';
export const colorPrimary900 = '#188652';
export const colorPrimary800 = '#19A463';
export const colorPrimary700 = '#1DBF73';
export const colorPrimary600 = '#3FCA89';
export const colorPrimary500 = '#62D49F';
export const colorPrimary400 = '#84DFB5';
export const colorPrimary300 = '#A6EACA';
export const colorPrimary200 = '#C9F4E0';
export const colorPrimary100 = '#E8FAF4';
export const colorBusinesses = {
    '100': '#F6F6FF',
    '200': '#E4E3FF',
    '300': '#B1ABFF',
    '400': '#B1ABFF',
    '500': '#B1ABFF',
    '600': '#584AFF',
    '700': '#584AFF',
    '800': '#2E25AD',
    '900': '#2E25AD',
    '1000': '#2E25AD',
    '1100': '#1E1692',
    '1200': '#0D084D'
};
export const colorBusiness1200 = '#0D084D';
export const colorBusiness1100 = '#1E1692';
export const colorBusiness1000 = '#2E25AD';
export const colorBusiness900 = '#2E25AD';
export const colorBusiness800 = '#2E25AD';
export const colorBusiness700 = '#584AFF';
export const colorBusiness600 = '#584AFF';
export const colorBusiness500 = '#B1ABFF';
export const colorBusiness400 = '#B1ABFF';
export const colorBusiness300 = '#B1ABFF';
export const colorBusiness200 = '#E4E3FF';
export const colorBusiness100 = '#F6F6FF';
export const colorPros = {
    '100': '#E8FFFC',
    '200': '#BEF5EE',
    '300': '#99EBE0',
    '400': '#73E1D3',
    '500': '#4DD6C5',
    '600': '#28CCB7',
    '700': '#02C2A9',
    '800': '#02B09A',
    '900': '#029F8B',
    '1000': '#028D7B',
    '1100': '#027C6C',
    '1200': '#026A5D'
};
export const colorPro1200 = '#026A5D';
export const colorPro1100 = '#027C6C';
export const colorPro1000 = '#028D7B';
export const colorPro900 = '#029F8B';
export const colorPro800 = '#02B09A';
export const colorPro700 = '#02C2A9';
export const colorPro600 = '#28CCB7';
export const colorPro500 = '#4DD6C5';
export const colorPro400 = '#73E1D3';
export const colorPro300 = '#99EBE0';
export const colorPro200 = '#BEF5EE';
export const colorPro100 = '#E8FFFC';
export const colorPinks = {
    '100': '#FFEFF7',
    '200': '#FFD7EB',
    '300': '#FFC0DE',
    '400': '#FFA9D2',
    '500': '#FF91C6',
    '600': '#FF7AB9',
    '700': '#FF62AD',
    '800': '#E05698',
    '900': '#C14A83',
    '1000': '#A23F6E',
    '1100': '#833359',
    '1200': '#642744'
};
export const colorPink1200 = '#642744';
export const colorPink1100 = '#833359';
export const colorPink1000 = '#A23F6E';
export const colorPink900 = '#C14A83';
export const colorPink800 = '#E05698';
export const colorPink700 = '#FF62AD';
export const colorPink600 = '#FF7AB9';
export const colorPink500 = '#FF91C6';
export const colorPink400 = '#FFA9D2';
export const colorPink300 = '#FFC0DE';
export const colorPink200 = '#FFD7EB';
export const colorPink100 = '#FFEFF7';
export const colorTeals = {
    '100': '#ECFCFF',
    '200': '#CDF5FB',
    '300': '#AFEDF7',
    '400': '#92E6F3',
    '500': '#75DFEE',
    '600': '#57D7EA',
    '700': '#3AD0E6',
    '800': '#30B8CB',
    '900': '#25A1B0',
    '1000': '#1B8996',
    '1100': '#10727B',
    '1200': '#065A60'
};
export const colorTeal1200 = '#065A60';
export const colorTeal1100 = '#10727B';
export const colorTeal1000 = '#1B8996';
export const colorTeal900 = '#25A1B0';
export const colorTeal800 = '#30B8CB';
export const colorTeal700 = '#3AD0E6';
export const colorTeal600 = '#57D7EA';
export const colorTeal500 = '#75DFEE';
export const colorTeal400 = '#92E6F3';
export const colorTeal300 = '#AFEDF7';
export const colorTeal200 = '#CDF5FB';
export const colorTeal100 = '#ECFCFF';
export const colorLimes = {
    '100': '#F8F9E5',
    '200': '#F1F4CB',
    '300': '#EDF2B3',
    '400': '#E8F094',
    '500': '#E3EE74',
    '600': '#DAEA3D',
    '700': '#D0E500',
    '800': '#BBCE00',
    '900': '#7D8900',
    '1000': '#687200',
    '1100': '#465A00',
    '1200': '#254200'
};
export const colorLime1200 = '#254200';
export const colorLime1100 = '#465A00';
export const colorLime1000 = '#687200';
export const colorLime900 = '#7D8900';
export const colorLime800 = '#BBCE00';
export const colorLime700 = '#D0E500';
export const colorLime600 = '#DAEA3D';
export const colorLime500 = '#E3EE74';
export const colorLime400 = '#E8F094';
export const colorLime300 = '#EDF2B3';
export const colorLime200 = '#F1F4CB';
export const colorLime100 = '#F8F9E5';
export const colorYellows = {
    '100': '#FFF7EE',
    '200': '#FFECD1',
    '300': '#FFE0B3',
    '400': '#FFD596',
    '500': '#FFCA79',
    '600': '#FFBE5B',
    '700': '#FFB33E',
    '800': '#E6A139',
    '900': '#CD8E33',
    '1000': '#B47C2E',
    '1100': '#9B6928',
    '1200': '#825723'
};
export const colorYellow1200 = '#825723';
export const colorYellow1100 = '#9B6928';
export const colorYellow1000 = '#B47C2E';
export const colorYellow900 = '#CD8E33';
export const colorYellow800 = '#E6A139';
export const colorYellow700 = '#FFB33E';
export const colorYellow600 = '#FFBE5B';
export const colorYellow500 = '#FFCA79';
export const colorYellow400 = '#FFD596';
export const colorYellow300 = '#FFE0B3';
export const colorYellow200 = '#FFECD1';
export const colorYellow100 = '#FFF7EE';
export const colorOranges = {
    '100': '#FFF2E9',
    '200': '#FEDFC9',
    '300': '#FECDAA',
    '400': '#FEBB8A',
    '500': '#FDA86A',
    '600': '#FD964B',
    '700': '#FC832B',
    '800': '#E37627',
    '900': '#CA6923',
    '1000': '#B25D1F',
    '1100': '#99501B',
    '1200': '#804317'
};
export const colorOrange1200 = '#804317';
export const colorOrange1100 = '#99501B';
export const colorOrange1000 = '#B25D1F';
export const colorOrange900 = '#CA6923';
export const colorOrange800 = '#E37627';
export const colorOrange700 = '#FC832B';
export const colorOrange600 = '#FD964B';
export const colorOrange500 = '#FDA86A';
export const colorOrange400 = '#FEBB8A';
export const colorOrange300 = '#FECDAA';
export const colorOrange200 = '#FEDFC9';
export const colorOrange100 = '#FFF2E9';
export const colorReds = {
    '100': '#FFEDED',
    '200': '#FED0D0',
    '300': '#FCB3B3',
    '400': '#FB9797',
    '500': '#FA7A7A',
    '600': '#F85D5D',
    '700': '#F74040',
    '800': '#D93C3C',
    '900': '#C43333',
    '1000': '#AB2D2D',
    '1100': '#912626',
    '1200': '#782020'
};
export const colorRed1200 = '#782020';
export const colorRed1100 = '#912626';
export const colorRed1000 = '#AB2D2D';
export const colorRed900 = '#C43333';
export const colorRed800 = '#D93C3C';
export const colorRed700 = '#F74040';
export const colorRed600 = '#F85D5D';
export const colorRed500 = '#FA7A7A';
export const colorRed400 = '#FB9797';
export const colorRed300 = '#FCB3B3';
export const colorRed200 = '#FED0D0';
export const colorRed100 = '#FFEDED';
export const colorPurples = {
    '100': '#F8F0FF',
    '200': '#E8D4FB',
    '300': '#D8B9F7',
    '400': '#C89DF3',
    '500': '#B881F0',
    '600': '#A866EC',
    '700': '#984AE8',
    '800': '#8842D0',
    '900': '#7739B9',
    '1000': '#6731A1',
    '1100': '#56288A',
    '1200': '#462072'
};
export const colorPurple1200 = '#462072';
export const colorPurple1100 = '#56288A';
export const colorPurple1000 = '#6731A1';
export const colorPurple900 = '#7739B9';
export const colorPurple800 = '#8842D0';
export const colorPurple700 = '#984AE8';
export const colorPurple600 = '#A866EC';
export const colorPurple500 = '#B881F0';
export const colorPurple400 = '#C89DF3';
export const colorPurple300 = '#D8B9F7';
export const colorPurple200 = '#E8D4FB';
export const colorPurple100 = '#F8F0FF';
export const colorBlues = {
    '100': '#F0F4FF',
    '200': '#D4DEFB',
    '300': '#B9C9F7',
    '400': '#9DB4F3',
    '500': '#819EF0',
    '600': '#6689EC',
    '700': '#446EE7',
    '800': '#3F63C8',
    '900': '#3453A8',
    '1000': '#284389',
    '1100': '#1D3369',
    '1200': '#122349'
};
export const colorBlue1200 = '#122349';
export const colorBlue1100 = '#1D3369';
export const colorBlue1000 = '#284389';
export const colorBlue900 = '#3453A8';
export const colorBlue800 = '#3F63C8';
export const colorBlue700 = '#446EE7';
export const colorBlue600 = '#6689EC';
export const colorBlue500 = '#819EF0';
export const colorBlue400 = '#9DB4F3';
export const colorBlue300 = '#B9C9F7';
export const colorBlue200 = '#D4DEFB';
export const colorBlue100 = '#F0F4FF';
export const colorGreens = {
    '100': '#E8FAF4',
    '200': '#C9F4E0',
    '300': '#A6EACA',
    '400': '#84DFB5',
    '500': '#62D49F',
    '600': '#3FCA89',
    '700': '#1DBF73',
    '800': '#19A463',
    '900': '#188652',
    '1000': '#126F43',
    '1100': '#0F5533',
    '1200': '#0B3A23'
};
export const colorGreen1200 = '#0B3A23';
export const colorGreen1100 = '#0F5533';
export const colorGreen1000 = '#126F43';
export const colorGreen900 = '#188652';
export const colorGreen800 = '#19A463';
export const colorGreen700 = '#1DBF73';
export const colorGreen600 = '#3FCA89';
export const colorGreen500 = '#62D49F';
export const colorGreen400 = '#84DFB5';
export const colorGreen300 = '#A6EACA';
export const colorGreen200 = '#C9F4E0';
export const colorGreen100 = '#E8FAF4';
export const colorGreys = {
    '100': '#FAFAFA',
    '200': '#F5F5F5',
    '300': '#EFEFF0',
    '400': '#E4E5E7',
    '500': '#DADBDD',
    '600': '#C5C6C9',
    '700': '#B5B6BA',
    '800': '#95979D',
    '900': '#74767E',
    '1000': '#62646A',
    '1100': '#404145',
    '1200': '#222325'
};
export const colorGrey1200 = '#222325';
export const colorGrey1100 = '#404145';
export const colorGrey1000 = '#62646A';
export const colorGrey900 = '#74767E';
export const colorGrey800 = '#95979D';
export const colorGrey700 = '#B5B6BA';
export const colorGrey600 = '#C5C6C9';
export const colorGrey500 = '#DADBDD';
export const colorGrey400 = '#E4E5E7';
export const colorGrey300 = '#EFEFF0';
export const colorGrey200 = '#F5F5F5';
export const colorGrey100 = '#FAFAFA';

export const tokenColors = {
    'white': '#fff',
    'black': '#000',
    'fiverrGreen': '#1DBF73',
    'body': '#62646A',
    'heading': '#404145',
    'background': '#fff',
    'border': '#EFEFF0',
    'link': '#1DBF73',
    'validationError': '#C43333',
    'validationWarning': '#CA6923',
    'validationSuccess': '#188652',
    'validationInformation': '#3453A8',
    'risingTalent': '#4F95F8'
};
export const colorRisingTalent = '#4F95F8';
export const colorValidationInformation = '#3453A8';
export const colorValidationSuccess = '#188652';
export const colorValidationWarning = '#CA6923';
export const colorValidationError = '#C43333';
export const colorLink = '#1DBF73';
export const colorBorder = '#EFEFF0';
export const colorBackground = '#fff';
export const colorHeading = '#404145';
export const colorBody = '#62646A';
export const colorFiverrGreen = '#1DBF73';
export const colorBlack = '#000';
export const colorWhite = '#fff';
